import { PackageProduct } from "../model";
import { getLocalApi } from "./localApi";
import apiConfig from "app/api/apiConfig.json";
import { mapPackageProduct } from "./mappers/mapPackageProduct";

export async function getPackageById(packageId: number): Promise<PackageProduct | void> {
    const localApi = await getLocalApi();

    return await localApi.fetchSingle(
        apiConfig.packages_get_by_id.replace("{packageId}", packageId.toString()),
        mapPackageProduct,
        "Failed to fetch package by id"
    );
}